import {
  ApiResListsType,
  ApiResponseType,
  OhsApiRequestName,
  RequestType,
} from 'global-services/api/OhsApiModels';
import OhsApiRequest from 'global-services/api/OhsApiRequest';
import { ModuleType } from 'global-services/constants/OhsObject';
import OhsFetchAll from 'global-services/OhsFetchAll';

import { OhsResourceCentreFilterPayload } from './OhsResourceCentreModels';

const getResources = (
  filterInfo: OhsResourceCentreFilterPayload
): Promise<ApiResListsType<any[]> | null> => {
  return OhsApiRequest(RequestType.Module, ModuleType.ResourceCenter, OhsApiRequestName.List, {
    filter: filterInfo,
  });
};

export const fetchResourceUrl = (_id: string): Promise<ApiResponseType<any> | null> => {
  return OhsApiRequest(RequestType.Module, ModuleType.ResourceCenter, OhsApiRequestName.Download, {
    _id,
  });
};

export default getResources;

export const getResourceItem = async (id: string) => {
  const res: any = await OhsFetchAll(getResources, {
    viewPreset: 'view_1',
    archived: false,
  });
  if (!res) return null;
  const target = (res?.items || []).find((item: any) => item?._id === id);

  return target;
};

export const getSupport = (payload: any) => {
  return OhsApiRequest(RequestType.Admin, ModuleType.MorphUser, OhsApiRequestName.Support, payload);
};

export const getFeedback = (payload: any) => {
  return OhsApiRequest(
    RequestType.Admin,
    ModuleType.MorphUser,
    OhsApiRequestName.FeedBack,
    payload
  );
};

export const addResourceCenter = (payload: any) => {
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.ResourceCenter,
    OhsApiRequestName.Create,
    payload
  );
};

export const editResourceCenter = (payload: any) => {
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.ResourceCenter,
    OhsApiRequestName.Edit,
    payload
  );
};

/**
 * Archives or unarchives a Resource Center item based on the `archive` flag.
 *
 * @param payload - An object containing the ID of the resource center item and the time zone.
 * @param payload._id - unique identifier of the resource center item.
 * @param payload.tz - time zone.
 * @param archive - whether to archive (true) or unarchive (false) the item.
 * @returns A Promise from the OhsApiRequest that resolves with the result of the API call.
 */
export const archiveUnarchiveResourceCenter = (
  payload: { _id: string; tz: string },
  archive: boolean
) => {
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.ResourceCenter,
    archive ? OhsApiRequestName.Archive : OhsApiRequestName.UnArchive,
    payload
  );
};
